export default {"src":"/_next/static/image/public/images/report_timer_ready.04f7f4d1fd8ab78edcc3384f5152a0de.svg","height":28,"width":29};